import React from 'react';
import { PreviewImage } from 'src/components';
import Button from 'src/components/button';
import Loader from 'src/components/loader';
import UploadImage from 'src/components/upload-image';
import useFetch from 'src/hooks/useFetch';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {}

const AccountInfoTab: React.FC<IProps> = ({}) => {
  const userInfoString: string | null = localStorage.getItem('userInfo');
  const businessId: string | undefined = JSON.parse(userInfoString ?? '{}')
    ?.businessInfo?.id;

  const { data: slideData, isLoading: loading } = useFetch(
    '/settings/wifiImages' + '/' + businessId
  );
  React.useEffect(() => {
    SetSliderImages(slideData);
  }, [slideData]);

  const [sliderImages, SetSliderImages] = React.useState<any>([]);
  const [imageName, SetImageName] = React.useState<string>('');
  const [isSubmitting, SetIsSubmitting] = React.useState<boolean>(false);

  const handleChange = (file: any) => {
    const binaryData = atob(file.split(',')[1]);

    // Calculate the size of the binary data
    const fileSizeInBytes: any = binaryData.length;
    // Convert the size to kilobytes (optional)
    SetSliderImages(
      file === null
        ? [...sliderImages]
        : [
            ...sliderImages,
            {
              url: file,
              name: imageName.replace(/\.[^/.]+$/, ''),
              size: fileSizeInBytes / 1024 / 1024,
            },
          ]
    );
    return file;
  };

  const handleSubmit = async () => {
    try {
      SetIsSubmitting(true);
      await Service.post('/settings/wifiImages', sliderImages);
      toastAlert('success', 'Images updated');
      SetIsSubmitting(false);
    } catch (err: any) {
      SetIsSubmitting(false);
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <div className="w-96">
      {loading ? (
        <Loader />
      ) : (
        <div>
          {sliderImages?.[0] ? (
            <PreviewImage
              file={sliderImages?.[0]?.url}
              label={'WiFi QR'}
              onClick={() => {
                SetSliderImages([]);
              }}
            />
          ) : (
            <UploadImage
              onChange={handleChange}
              name={'slider'}
              label={'Image'}
              cropAsp={1 / 1}
              btnLabel={''}
              SetImageName={SetImageName}
            />
          )}
          <div className="flex items-center justify-end">
            <Button
              text={'Save Details'}
              variant="primary"
              onClick={handleSubmit}
              isSubmitting={isSubmitting}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(AccountInfoTab);
